/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtResponse } from '../../models/ot-response';

export interface GetUnplannedOts$Params {
  /**
   * idSite
   */
  idSite: string;

  /**
   * previsionDateDebut
   */
  previsionDateDebut?: string;

  /**
   * previsionDateFin
   */
  previsionDateFin?: string;
}

export function getUnplannedOts(
  http: HttpClient,
  rootUrl: string,
  params: GetUnplannedOts$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<OtResponse>>> {
  const rb = new RequestBuilder(rootUrl, getUnplannedOts.PATH, 'get');
  if (params) {
    rb.query('idSite', params.idSite, {});
    rb.query('previsionDateDebut', params.previsionDateDebut, {});
    rb.query('previsionDateFin', params.previsionDateFin, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OtResponse>>;
    })
  );
}

getUnplannedOts.PATH = '/v2/ots/unplanned_ots';
